module.exports = __webpack_public_path__ + "static/media/logBackgroundPic.0221a19f.jpg";